import { SectionHeader } from "#/components/SectionHeader";
import { Badge } from "#/components/ui/badge";
import {
  getPublishedChangelogEntries,
  UPDATE_CATEGORY_LABELS,
  type ChangelogEntry,
  type UpdateCategory,
} from "#/content/updates";

const updateDateFormatter = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "UTC",
});

function formatUpdateDate(date: string): string {
  return updateDateFormatter.format(new Date(`${date}T00:00:00.000Z`));
}

function categoryBadgeVariant(category: UpdateCategory): "default" | "secondary" | "accent" {
  switch (category) {
    case "balance":
      return "accent";
    case "bugfix":
      return "secondary";
    default:
      return "default";
  }
}

function ChangelogEntrySection({ entry }: { entry: ChangelogEntry }) {
  return (
    <section id={entry.id} className="scroll-mt-24">
      <div className="flex flex-col gap-1">
        <p className="text-sm text-muted-foreground">{formatUpdateDate(entry.date)}</p>
        <SectionHeader>{entry.title}</SectionHeader>
      </div>
      <ul className="mt-4 flex flex-col gap-3">
        {entry.items.map((item, index) => (
          <li key={`${entry.id}-${index}`} className="flex flex-col gap-2 sm:flex-row sm:gap-3">
            <Badge variant={categoryBadgeVariant(item.category)} className="w-20 shrink-0">
              {UPDATE_CATEGORY_LABELS[item.category]}
            </Badge>
            <span className="text-sm text-foreground">{item.text}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ChangelogTimeline() {
  return (
    <div className="flex flex-col gap-10">
      {getPublishedChangelogEntries().map((entry) => (
        <ChangelogEntrySection key={entry.id} entry={entry} />
      ))}
    </div>
  );
}
